import yxpapi from '@yxpapi';

export default new yxpapi.JAVAAPI({
    /* 模板列表 */
    getTplList: {
        url: '/api/crm/template/list',
        method: 'get',
        // options: {
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        // },
    },
    /* 模板启用禁用 */
    updateValid: {
        url: '/api/crm/template/updateValid',
        method: 'post',

    },
});
